export const MODAL_TYPE = Object.freeze({
  PROMOTION_AWARENESS: 'promotion-awareness',
  ECONOMIC_PLAN_EXPIRED: 'economic-plan-expired',
  FLEX_MODE_ONBOARDING_MODAL: 'you-are-on-flex-mode',
  CHALLENGE_COACHMARK: 'challenge-coachmark',
  RATE_FIRST_DELIVERY_MODAL: 'rate-first-delivery',
  COACH_MARK_CALENDAR_VIEW: 'coach-mark-calendar-view',
  EARLY_USER_ONBOARDING_COACHMARK: 'early-user-onboarding-coachmark',
  CHANGE_DELIVERY_MODAL: 'change-delivery'
})
export const COMPARE_PLANS_LOCALSTORAGE_KEY = 'tour-compare-plans-modal-viewed'
